import './filter.js.coffee';# Added by Script
class Customer.NestedFilterCollection extends Backbone.Collection
  url: '/customer/filters'

  model: Customer.Filter

  modelId: (attrs) ->
    "#{attrs.type}-#{attrs.id}"

  initialize: =>
    super
    @publicFolder = new Customer.FilterFolder
      name: I18n.t('customer.dashboard.filters.filter_collections.main_public')
      id: 'public-filter'
      open: true
    @_bubbleUpEvents @publicFolder
    @privateFolder = new Customer.FilterFolder
      name: I18n.t('customer.dashboard.filters.filter_collections.main_private')
      user_id: Keepcon.current_user.id
      id: 'private-filter'
    @_bubbleUpEvents @privateFolder
    @listenTo(Backbone, 'operator:status:change', () =>
      @fetch(success: () =>
        Backbone.trigger('filter:collection:fetch', @getFilters())
      )
    )
    @tabManager = null

  _bubbleUpEvents: (child) ->
    @listenTo(child, 'destroy:filter', (filter) -> @trigger('destroy:filter', filter))

  fetch: (options = {}) =>
    options.success ||= (() ->)
    Backbone.ajax
      url: @url
      method: 'GET'
      dataType: 'json'
      success: (response) =>
        @reset()
        _.each response, (item) =>
          if item.query
            item.query = JSON.parse item.query
            @add new Customer.Filter(item)
          else
            @add new Customer.FilterFolder(item)
        options.success()

  saveOrder: (orderedFilters) ->
    @models = _.sortBy(@models, (mod) ->
      r = orderedFilters.indexOf(String(mod.id))
      r = 1000 if r == -1
      r
    )

    @models = _.map(@models, (model) ->
      if model.get('children')
        model.set 'children', _.sortBy(model.get('children'), (mod) ->
          r = undefined
          r = orderedFilters.indexOf(String(mod.id))
          if r == -1
            r = 1000
          r
        )
      model
    )


    $.post('/customer/dashboard/filter_order', {new_order: orderedFilters})
    @

  getFilters: ->
    _.flatten(model.allFilters() for model in @models)

  setTabManager: (tabMgr) =>
    @tabManager = tabMgr

  visibleFilters: ->
    openedFilters=[]
    openedFilters = @tabManager.getOpenedFilters() if @tabManager
    publicModels = if @publicFolder.isOpen() then @_publicFiltersAndFolders() else []
    privateModels = if @privateFolder.isOpen() then @_privateFiltersAndFolders() else []
    res = _.flatten(model.visibleFilters() for model in [publicModels..., privateModels..., openedFilters...])
    _.uniq(res, false,  (filter) => filter.cid)

  _publicFiltersAndFolders: ->
    model for model in @models when model.isGlobal()

  _privateFiltersAndFolders: ->
    model for model in @models when not model.isGlobal()

  getPublicSection: ->
    @publicFolder.set('children', @_publicFiltersAndFolders())
    @publicFolder

  getPrivateSection: ->
    @privateFolder.set('children', @_privateFiltersAndFolders())
    @privateFolder

  getPublicFoldersFor: (filterOrFolder) ->
    condition = (filterOrFolder) -> !filterOrFolder.isFilter() && filterOrFolder.isGlobal()
    parents = _.select(@models, (filterOrFolder) -> condition(filterOrFolder))
    parents

  getPrivateFoldersFor: (filterOrFolder) ->
    condition = (filterOrFolder) -> filterOrFolder.isFilter() || filterOrFolder.isGlobal()
    parents = _.reject(@models, (filterOrFolder) -> condition(filterOrFolder))
    parents

  getMapIdTree: ->
    mapFilter = (filters) => return filters.map((child) => (
      if child.isFilter() then child.get('id') else mapFilter(child.get('children')) )
    ).sort()
    tree = []
    tree['public'] = mapFilter(@_publicFiltersAndFolders())
    tree['private'] = mapFilter(@_privateFiltersAndFolders())
    return tree

  isCollectionChanged: (previousMapTree) ->
    _isPublicEqual = _.isEqual(previousMapTree['public'] || [], @getMapIdTree()['public'])
    _isPrivateEqual = _.isEqual(previousMapTree['private'] || [], @getMapIdTree()['private'])
    !_isPublicEqual || !_isPrivateEqual

  addFilter: (filter) ->
    @_removeFromOldCollection(filter)
    if filter.get('filter_collection_id') == null
      @_pushToBaseFolder(filter)
    else
      folder = undefined
      _.each(@models, (filterOrFolder) =>
        if !filterOrFolder.isFilter() && filterOrFolder.id == filter.getFilterCollectionId()
          folder = filterOrFolder
        else
          child = _.find(filterOrFolder.get('children'), (children) => @_folderFound(children, filter))
          folder = child if child
      )
      if folder
        folder.addChild(filter)
        @remove(filter)

  addFolder: (folder) ->
    @_removeFromOldCollection(folder)
    if folder.get('filter_collection_id') == null
      @_pushToBaseFolder(folder)
    else
      parentFolder = _.find(@models, (filterOrFolder) => @_folderFound(filterOrFolder, folder))
      parentFolder.addChild(folder)
      @remove(folder)

  _removeFromOldCollection: (filterOrFolder) ->
    _.each(@models, (f) ->
      if f.id == filterOrFolder.getOldFilterCollectionId()
        f.get('children').remove(filterOrFolder)
      else
        _.each(f.get('children'), (child) ->
          if child.id == filterOrFolder.get('id')
            child.get('children').remove(filterOrFolder)
        )
    )

  _pushToBaseFolder: (filterOrFolder) ->
    @add(filterOrFolder)
    if filterOrFolder.isGlobal()
      @publicFolder.addChild(filterOrFolder)
    else
      @privateFolder.addChild(filterOrFolder)

  _folderFound: (elemToAnalyze, baseElement) ->
    !elemToAnalyze.isFilter() && elemToAnalyze.id == baseElement.getFilterCollectionId()
